import React from "react";
import { getLanguageSection } from "../shared/services/languageService";

function Webinar() {
  const language = getLanguageSection("webinar");
  const videoSrc = `${process.env.PUBLIC_URL}/videos/${encodeURIComponent("Webinar Marival Resorts by Marc Murphy.mp4")}`;

  return (
    <div id="webinar" className="mr-ui bg-[#f3f5fb] px-4 py-10 md:px-8">
      <div className="mx-auto w-full max-w-5xl">
        <div className="text-center text-marival-navy">
          <h1 className="m-0 font-serif text-3xl font-bold leading-tight md:text-4xl">{language.title}</h1>
          <p className="m-0 mt-3 text-base leading-7 text-slate-600">{language.subtitle}</p>
        </div>

        <div className="mt-8 overflow-hidden rounded-2xl border border-slate-200 bg-black shadow-marival">
          <video className="h-auto w-full" controls controlsList="nodownload" preload="metadata">
            <source src={videoSrc} type="video/mp4" />
            {language.unsupported}
          </video>
        </div>
      </div>
    </div>
  );
}

export default Webinar;
